module.exports = __webpack_public_path__ + "static/media/mt-ut-img-5.640db062.webp";